// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3V--d","actionsCol":"EnrolledClinics_actionsCol__RKoUM"};